import gsap from 'gsap';

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { isMobile } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';

export class ScrollItem__HighlightWorks extends ScrollItem__BlockDefault {
    _paths = [];
    _height;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._paths = GetBy.selector('.logo-full svg', this.item);
        gsap.set(this._paths, { y: '100%' });
    }

    moveFunction() {
        const p = Maths.clamp(1 - this.progressInside, 0, 1)

        if (p < .5) {
            const n = Maths.normalize(this._offset, 0, p);

            for (let i = 0; i < this._paths.length; i++) {
                const path = this._paths[i];
                const segment = (1 / this._paths.length) * i;
                const segmentNext = (1 / this._paths.length) * (i + 1);
                const nIndividual = Maths.normalize(segmentNext, segment, n);
                const y = Maths.clamp((1 - nIndividual) * 100, 0, 100);
                gsap.set(path, { y: `${y}%` });
            }
        } else {
            if (!isMobile) {
                const n = Maths.normalize(1, 1 - this._offset, p);

                for (let i = 0; i < this._paths.length; i++) {
                    const path = this._paths[i];
                    const segment = (1 / this._paths.length) * i;
                    const segmentNext = (1 / this._paths.length) * (i + 1);
                    const nIndividual = Maths.normalize(segment, segmentNext, n);
                    const y = Maths.clamp((1 - nIndividual) * 100, 0, 100);
                    gsap.set(path, { y: `-${y}%` });
                }
            } else {
                const n = Maths.normalize(.8, .7, p);

                for (let i = 0; i < this._paths.length; i++) {
                    const path = this._paths[i];
                    const segment = (1 / this._paths.length) * i;
                    const segmentNext = (1 / this._paths.length) * (i + 1);
                    const nIndividual = Maths.normalize(segment, segmentNext, n);
                    const y = Maths.clamp((1 - nIndividual) * 100, 0, 100);
                    gsap.set(path, { y: `-${y}%` });
                }
            }
        }
    }

    resize() {
        super.resize();

        this._height = this.item.offsetHeight;
        this._offset = Metrics.HEIGHT / this.item.offsetHeight / 2;
        // if (isMobile) this._offsetMobile = Metrics.HEIGHT / this.item.offsetHeight / 2;
    }
}

Scroll._registerClass('HighlightWorks', ScrollItem__HighlightWorks);
